<nav class="navbar navbar-expand-sm navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/"><img src="assets/images/xprr_brand.png" alt="XPRR" /></a>
    <button (click)="collapsed = !collapsed" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#primaryNav" aria-controls="primaryNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-between" [class.collapse]="collapsed" id="primaryNav">
      <app-header-search />

      <!-- ADMIN ONLY ROLE -->
      @if (isAdmin()) {
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown" ngbDropdown #adminDrop="ngbDropdown">
            <a class="nav-link dropdown-toggle"
              id="admin-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              ngbDropdownAnchor
              (mouseenter)="$event.stopPropagation(); adminDrop.open(); accountDrop.close();">
              <fa-icon [icon]="faCog" class="text-danger" />
            Admin</a>
            <div class="dropdown-menu" aria-labelledby="admin-dropdown" ngbDropdownMenu (mouseleave)="$event.stopPropagation(); adminDrop.close();">
              <a class="dropdown-item" ngbDropdownItem routerLink="/admin/acl"> <fa-icon [icon]="faShieldAlt" class="text-danger" /> ACL</a>
              <a class="dropdown-item" ngbDropdownItem routerLink="/admin/users"> <fa-icon [icon]="faUser" class="text-danger" /> Users</a>
            </div>
          </li>
          <span class="navbar-text border-end d-lg-inline-block d-md-none d-sm-none d-none">&nbsp;</span>
          <li class="nav-item dropdown" ngbDropdown #accountDrop="ngbDropdown">
            <a class="nav-link dropdown-toggle"
              id="account-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              ngbDropdownAnchor
              (mouseenter)="$event.stopPropagation(); accountDrop.open(); adminDrop.close();">
              <fa-icon [icon]="faUserCircle" class="text-danger" />
            {{user()?.fname}} {{user()?.lname}}</a>
            <div class="dropdown-menu" aria-labelledby="account-dropdown" ngbDropdownMenu
              (mouseleave)="$event.stopPropagation(); accountDrop.close();">
              <a class="dropdown-item" ngbDropdownItem (click)="logout()" routerLink="/auth/logout">Logout</a>
            </div>
          </li>
        </ul>
      }

      <!-- ALL OTHER ROLES -->
      <div class="d-flex">
        @if (!isAdmin()) {
          <ul class="navbar-nav ms-auto">
            <li class="nav-item dropdown" ngbDropdown #accountDrop="ngbDropdown">
              <a class="nav-link dropdown-toggle"
                id="account-dropdown-ro"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                ngbDropdownAnchor
                (mouseenter)="$event.stopPropagation(); accountDrop.open();">
                <fa-icon [icon]="faUserCircle" class="text-danger" />
              My Account</a>
              <div class="dropdown-menu" aria-labelledby="account-dropdown-ro" ngbDropdownMenu
                (mouseleave)="$event.stopPropagation(); accountDrop.close();">
                <a class="dropdown-item" ngbDropdownItem (click)="logout()" routerLink="/auth/logout">Logout</a>
              </div>
            </li>
          </ul>
        }
      </div>


    </div>
  </div>
</nav>

<!-- Sub Nav -->
<div class="nav-scroller bg-white shadow-sm">
  <div class="container-fluid">
    <nav class="nav nav-underline">
      <a class="nav-link active" routerLink="/">Dashboard</a>

      @if (canEditLink()) {
        <a class="nav-link" routerLink="/maintenance/create-link">Create Link</a>
      }

      <li class="nav-item dropdown" ngbDropdown #maintDrop="ngbDropdown">
        <a class="nav-link dropdown-toggle" id="maintdropdown" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false" ngbDropdownAnchor (mouseenter)="$event.stopPropagation(); maintDrop.open();">Maintenance</a>
        <div class="dropdown-menu" aria-labelledby="maint-dropdown" ngbDropdownMenu (mouseleave)="$event.stopPropagation(); maintDrop.close();">
          @if (canEditAffiliate()) {
            <a ngbDropdownItem class="dropdown-item" routerLink="/maintenance/create-publisher">Create Publisher</a>
          }
          <a ngbDropdownItem class="dropdown-item" routerLink="/maintenance/publishers">Publishers</a>
          <a ngbDropdownItem class="dropdown-item" routerLink="/maintenance/links">Links</a>
          <a ngbDropdownItem class="dropdown-item" routerLink="/maintenance/sites">Sites</a>
          <a ngbDropdownItem class="dropdown-item" routerLink="/maintenance/verticals">Verticals</a>
          @if (canUseCidUpdater()) {
            <a ngbDropdownItem class="dropdown-item" routerLink="/maintenance/mass-url-update">Mass URL Update</a>
          }
        </div>
      </li>

      <a class="nav-link" routerLink="/monitor" [queryParams]="{isWidescreen: true}">Link Monitor</a>
      <a class="nav-link" routerLink="/search/powersearch" [queryParams]="{isWidescreen: true}">Search</a>

      <a class="ms-auto nav-link clickable" tabindex="0" role="button" (click)="toggleWidescreen()" (keydown.enter)="toggleWidescreen()">
        <fa-icon [icon]="faTv" class="text-danger" />
      </a>
    </nav>

  </div>
</div>

